<div class="file-upload-container">
  <h3>Import API Objects</h3>

  <div class="file-input-section">
    <input
      type="file"
      id="fileInput"
      [attr.multiple]="null"
      (change)="onFileSelected($event)"
      class="file-input"
      accept=".json"
    />
  </div>
  <div class="file-input-section">
    <mat-checkbox 
      class="file-input" 
      name="createStep" 
      matTooltip="Create Step"
      [(ngModel)]="createStep"
    >
      <span class="checkbox">Create Step</span>
    </mat-checkbox>
  </div>
  
  <div class="file-input-section" *ngIf="createStep">
    <mat-form-field appearance="outline" class="step-name-field">
      <input matInput placeholder="Enter Step Name" [(ngModel)]="stepName"  class="file-input" required>
    </mat-form-field>
  </div>

  <div class="selected-files" *ngIf="selectedFiles.length > 0">
    <h4>Selected Files:</h4>
    <ul>
      <li *ngFor="let file of selectedFiles" class="file-item">
        <span class="file-name">{{ file.name }}</span>
        <button type="button" (click)="removeFile(file)" class="remove-btn">
          ×
        </button>
      </li>
    </ul>
  </div>

  <div class="actions">
    <button type="button" (click)="onCancel()" class="cancel-btn">
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      class="submit-btn"
      [disabled]="selectedFiles.length === 0"
    >
      Submit
    </button>
  </div>
</div>
